import PropTypes from 'prop-types';

Container.propTypes = {
  children: PropTypes.any,
};

export default function Container({ children }) {
  return <main>{children}</main>;
}
